import { createI18n } from 'vue-i18n'
import storage from 'store'
import moment from 'moment'

// default lang
import zhCn from './lang/zh-CN'

export const defaultLang = 'zh-CN'

const messages = {
  'zh-CN': {
    ...zhCn,
  },
}

const i18n = createI18n({
  legacy: true, // 使用 Legacy API 模式以兼容 this.$i18n
  locale: defaultLang,
  fallbackLocale: defaultLang,
  messages,
  silentTranslationWarn: true,
})

const loadedLanguages = [defaultLang]

function setI18nLanguage(lang) {
  // 在 legacy 模式下，确保 locale 是 ref 对象
  if (i18n.global.locale && typeof i18n.global.locale === 'object' && 'value' in i18n.global.locale) {
    i18n.global.locale.value = lang
  } else {
    // 如果 locale 不是 ref，直接设置
    i18n.global.locale = lang
  }
  // request.headers['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync(lang = defaultLang) {
  return new Promise((resolve) => {
    // 缓存语言设置
    storage.set('lang', lang)
    // 获取当前语言值
    const currentLang = i18n.global.locale && typeof i18n.global.locale === 'object' && 'value' in i18n.global.locale
      ? i18n.global.locale.value
      : i18n.global.locale
    
    if (currentLang !== lang) {
      if (!loadedLanguages.includes(lang)) {
        return import(
          /* webpackChunkName: "lang-[request]" */ `./lang/${lang}`
        ).then((msg) => {
          const locale = msg.default
          i18n.global.setLocaleMessage(lang, locale)
          loadedLanguages.push(lang)
          moment.updateLocale(locale.momentName, locale.momentLocale)
          return setI18nLanguage(lang)
        })
      }
      return resolve(setI18nLanguage(lang))
    }
    return resolve(lang)
  })
}

export function i18nRender(key) {
  return i18n.global.t(`${key}`)
}

export default i18n
